module.exports = __webpack_public_path__ + "static/media/securitydeposit.e2f1dfca.png";